import React from "react";
import { QRCodeSVG } from "qrcode.react";
import Box from "@mui/material/Box";
import { qrLogo } from "../images";

export const QRCodeComponent = ({
  value,
  size,
  icon,
  src,
  iconSize,
  level,
  qrRef,
  borderRadius,
  ...props
}) => {
  const imageSettings = icon
    ? {
        src: src || qrLogo,
        height: iconSize,
        width: iconSize,
        excavate: true,
      }
    : {};

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        margin: 0,
      }}
      className="qr-code"
      ref={qrRef}
    >
      <QRCodeSVG
        level={level}
        value={value}
        imageSettings={imageSettings}
        includeMargin={true}
        {...props}
        style={{
          ...props.style,
          height: size,
          width: size,
          borderRadius: borderRadius,
          border: "1px solid #F6F3F3",
        }}
        renderAs="svg"
        options={{
          rendererOpts: {
            modules: {
              shapeRendering: "crispEdges", // Set for each module
            },
          },
        }}
      />
    </Box>
  );
};
